var _rect, _ellipse, _ellipse2, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 80,
    viewBox: "0 0 99 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 22,
    width: 35,
    height: 35,
    rx: 17.5,
    transform: "rotate(90 43 22)",
    fill: "#F1EDF7"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.5873,
    cy: 11.6471,
    rx: 2.64706,
    ry: 2.64706,
    transform: "rotate(90 82.5873 11.6471)",
    fill: "#00FFFF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 93.4375,
    cy: 65.5,
    rx: 5.5,
    ry: 5.5,
    transform: "rotate(90 93.4375 65.5)",
    fill: "#EB3366"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.1574 65.9281H82.5859V63.571C82.5859 53.4751 75.5334 45.0263 66.0859 42.8826",
    stroke: "url(#paint0_linear_1_32954)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0078 14.3686C59.7612 14.1747 60.551 14.0715 61.365 14.0715C66.5724 14.0715 70.7935 18.2928 70.7935 23.5001C70.7935 28.7074 66.5724 32.9287 61.365 32.9287C60.551 32.9287 59.7612 32.8255 59.0078 32.6316",
    stroke: "url(#paint1_linear_1_32954)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5112 42.3572C30.7948 42.3572 21.2969 51.8551 21.2969 63.5715V65.9286H63.7254V63.5715C63.7254 51.8551 54.2275 42.3572 42.5112 42.3572Z",
    stroke: "url(#paint2_linear_1_32954)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5145 32.9287C47.7218 32.9287 51.9431 28.7074 51.9431 23.5001C51.9431 18.2928 47.7218 14.0715 42.5145 14.0715C37.3072 14.0715 33.0859 18.2928 33.0859 23.5001C33.0859 28.7074 37.3072 32.9287 42.5145 32.9287Z",
    stroke: "url(#paint3_linear_1_32954)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_32954",
    x1: 64.3167,
    y1: 68.1174,
    x2: 85.9335,
    y2: 67.2312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57249C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB3366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_32954",
    x1: 57.744,
    y1: 34.7201,
    x2: 73.1908,
    y2: 34.1673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57249C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB3366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_32954",
    x1: 16.7473,
    y1: 68.1679,
    x2: 71.8416,
    y2: 62.4893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57249C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB3366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_32954",
    x1: 31.0639,
    y1: 34.7201,
    x2: 55.7295,
    y2: 33.3077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57249C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB3366"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.7bdd4c7c92d4b187613467b66332f876.svg";
export { ForwardRef as ReactComponent };